export class RiskNotFoundError extends Error {
  constructor(
    public risk: string,
    message = `Risk ${risk} not found`
  ) {
    super(message);
  }
}

export class DataIntegrityError extends Error {
  constructor(public message: string) {
    super(message);
  }
}
